import { getPlatformComponent } from '@direct-frontend/platform-code';
import { ComponentType } from 'react';

import { ModalProps } from './types';

/**
 * Модальное окно (desktop/mobile), контент — OverlayContent
 */
export const Modal = getPlatformComponent<ComponentType<ModalProps>>({
    desktop: import('./Modal@desktop'),
    mobile: import('./Modal@mobile'),
});
